import styles from './ContactUsDealerInformationSectionHeader.module.scss';
import cx from 'classnames';
import { useSelector } from 'react-redux';
import { CatHeading } from '@blocks-react/components/Heading';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';

const ContactUsDealerInformationSectionHeader = () => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const dealerName = useSelector(s => s.dealer?.dealerName);

  return (
    <div
      className={cx(
        'cat-u-padding-md text-capitalize',
        styles['contactUsPage__dealerInformationSection__header']
      )}
    >
      <CatHeading variant={isMD ? 'title' : 'headline'}>
        {dealerName ? dealerName.toLowerCase() : ''}
      </CatHeading>
    </div>
  );
};

export default ContactUsDealerInformationSectionHeader;
